import addedToCart from "@/js/events/product/added-to-cart";

export default function (){
    addedToCart()
}
